import fetch from "../fetch";

export default ({ fundId }) =>
  fetch({
    path: `/hy/funds/${fundId}/performance-fees`,
  });
